import { render, staticRenderFns } from "./NewProfile.vue?vue&type=template&id=4d9dc70a&scoped=true"
import script from "./NewProfile.vue?vue&type=script&lang=js"
export * from "./NewProfile.vue?vue&type=script&lang=js"
import style0 from "./NewProfile.vue?vue&type=style&index=0&id=4d9dc70a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9dc70a",
  null
  
)

export default component.exports